import { Injectable } from '@angular/core';

declare var cordova: any;

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage: any;
  private isReady = false;
  private isCordovaApp = false;

  constructor() {
    // Verificar si es un entorno Cordova
    this.isCordovaApp = !!(window.cordova);

    if (this.isCordovaApp) {
      // Añadir un manejador para el evento deviceready
      document.addEventListener('deviceready', () => {
        this.initializeSecureStorage();
      }, false);
    } else {
      // Asignar isReady a true para el entorno web (sin SecureStorage)
      this.isReady = true;
    }
  }

  // Inicializa el almacenamiento seguro en Cordova
  private initializeSecureStorage() {
    if (cordova && cordova.plugins && cordova.plugins.SecureStorage) {
      this.storage = new cordova.plugins.SecureStorage(() => {
        this.isReady = true;
      }, (error) => {
        console.error('Error initializing SecureStorage:', error);
      }, 'monific_app_storage');
    } else {
      console.error('SecureStorage plugin not available');
    }
  }

  private ensureStorageReady() {
    if (!this.isReady) {
      throw new Error('SecureStorage is not ready. Ensure the deviceready event has been fired.');
    }
  }

  // Métodos públicos para almacenamiento en ambos entornos
  async setItem(key: string, value: string) {
    if (this.isCordovaApp) {
      this.ensureStorageReady();
      return new Promise<void>((resolve, reject) => {
        this.storage.set(resolve, reject, key, value);
      });
    } else {
      // Almacenamiento alternativo en navegadores web
      localStorage.setItem(key, value);
    }
  }

  async getItem(key: string): Promise<string> {
    if (this.isCordovaApp) {
      this.ensureStorageReady();
      return new Promise<string>((resolve, reject) => {
        this.storage.get(resolve, reject, key);
      });
    } else {
      // Almacenamiento alternativo en navegadores web
      const value = localStorage.getItem(key);
      return value !== null ? Promise.resolve(value) : Promise.reject('Item not found');
    }
  }

  async removeItem(key: string) {
    if (this.isCordovaApp) {
      this.ensureStorageReady();
      return new Promise<void>((resolve, reject) => {
        this.storage.remove(resolve, reject, key);
      });
    } else {
      // Almacenamiento alternativo en navegadores web
      localStorage.removeItem(key);
    }
  }
}
